import { currentStore } from "@/mocks/dashboard";

function getDates() {
  const now = new Date();
  let hijri = "";
  let gregorian = "";
  try {
    hijri = new Intl.DateTimeFormat("ar-SA-u-ca-islamic-nu-latn", {
      day: "numeric",
      month: "long",
      year: "numeric",
    }).format(now);
    gregorian = new Intl.DateTimeFormat("ar-SA-u-nu-latn", {
      weekday: "long",
      day: "numeric",
      month: "long",
      year: "numeric",
    }).format(now);
  } catch {
    gregorian = now.toLocaleDateString("en-GB");
  }
  return { hijri, gregorian };
}

export default function WelcomeSection() {
  const { hijri, gregorian } = getDates();

  return (
    <div className="yc-fade-up flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
      <div>
        <h2 className="text-2xl font-bold text-foreground-950">
          مرحبًا، {currentStore.ownerName}
        </h2>
        <div className="mt-2 flex flex-wrap items-center gap-x-4 gap-y-1 text-sm text-foreground-500">
          <span className="inline-flex items-center gap-1.5">
            <span className="w-4 h-4 flex items-center justify-center text-foreground-400">
              <i className="ri-calendar-line"></i>
            </span>
            {gregorian}
          </span>
          {hijri && (
            <span className="inline-flex items-center gap-1.5">
              <span className="w-4 h-4 flex items-center justify-center text-foreground-400">
                <i className="ri-moon-line"></i>
              </span>
              {hijri}
            </span>
          )}
        </div>
      </div>
      <div className="inline-flex items-center gap-2 self-start md:self-auto rounded-full bg-primary-50 px-4 py-2 text-sm font-medium text-primary-700">
        <span className="w-4 h-4 flex items-center justify-center">
          <i className="ri-store-3-line"></i>
        </span>
        {currentStore.brandName}
      </div>
    </div>
  );
}